import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchChangeDevice = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'PATCH',
    url: `/monitoring-operator/device/transfer`,
    data: payload,
  });

  return data?.data;
};

export default patchChangeDevice;
